import { defineMessages } from 'react-intl';

import type { FullHeadMPRPaneLayout } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import { MPRTool } from './types';

export const mprControlsDefaultMessages = defineMessages<MPRTool>({
  mainMode: {
    id: 'mprControlTools.axes',
    defaultMessage: 'Axes',
  },
  contrastBrightnessMode: {
    id: 'mprControlTools.brightness',
    defaultMessage: 'Brightness / Contrast',
  },
  zoomMode: {
    id: 'mprControlTools.zoom',
    defaultMessage: 'Zoom',
  },
  panMode: {
    id: 'mprControlTools.pan',
    defaultMessage: 'Pan',
  },
  scrollThroughVolumeMode: {
    id: 'mpr2ControlTools.scrollThroughVolumeMode',
    defaultMessage: 'Scroll through volume',
  },
  rotateMode: {
    id: 'mprControlTools.rotate',
    defaultMessage: 'Rotate',
  },
  reset: {
    id: 'mprControlTools.reset',
    defaultMessage: 'Reset',
  },
});

export const mprPaneLayoutToggleMessages =
  defineMessages<FullHeadMPRPaneLayout>({
    one_plus_two: {
      id: 'mpr.tools.paneLayout.switchToOnePlusTwo',
      defaultMessage: 'Switch to 1 large + 2 small views',
    },
    three_columns: {
      id: 'mpr.tools.paneLayout.switchToThreeColumns',
      defaultMessage: 'Switch to 3-column views',
    },
  });
